export enum ProtectionLevel {
    public = "public",
    private = "private",
    sensitive = "sensitive",
    protected = "protected",
    developer = "developer",
    camoowealSecret = "camoowealSecret"
}

export function groupAccessToProtectionLevel(
    groups?: string[] | null
): ProtectionLevel | undefined {
    if (groups) {
        const enumType = ProtectionLevel;
        for (const key of Object.keys(enumType)) {
            if (groups.includes(key)) {
                return key as unknown as ProtectionLevel;
            }
        }
    }
    return undefined;
}

export function protectionLevelToGroups(level: ProtectionLevel) {
    return [level, `${level}Readonly`];
}

export type CachedUserInfo = {
    groups: string[];
    id: string;
    email: string;
};

export class User {
    constructor(private readonly _info: CachedUserInfo) {}

    public get id(): string {
        return this._info.id;
    }

    public inGroup(group: string): boolean {
        return this._info.groups?.includes(group) ?? false;
    }

    public isDeveloper(): boolean {
        return this.inGroup("developer");
    }

    public isAdmin(): boolean {
        return this.inGroup("admins");
    }

    public canView(groups: string[] | undefined | null): boolean {
        if (groups) {
            const pl = groupAccessToProtectionLevel(groups) as string;
            return this.inGroup(pl) || this.inGroup(pl + "Readonly");
        }
        return false;
    }

    public canEdit(groups: string[] | undefined | null): boolean {
        if (groups) {
            const pl = groupAccessToProtectionLevel(groups) as string;
            return this.inGroup(pl);
        }
        return false;
    }
}
